// extracted by mini-css-extract-plugin
export var flush = "BuQjF74jhOgXXNSm6z6D";
export var headerWithIcon = "l4cHBxEsrG_edNIuv95w";
export var leftBorder = "JApvzspAL7Jt5JoJ1JWk";
export var leftBorderInfo = "IAOOOV59KyvNcdqUWJpA";
export var leftBorderNegative = "WjH2qrJiAvyzp9X42BNt";
export var leftBorderPositive = "dzEjr2iqdLLFxIyZoMo4";
export var leftBorderWarning = "HRbH1tgtJJzn3K58FxZV";
export var message = "RI0Owo5tK6VjK5EZYmN5";
export var messageHeader = "KlctTlWPSChcxXL0u3j6";
export var trailingItem = "AtcVpcLMCePQq6r33bus";
export var vertical = "uEWP_a5I_cP0eo27TwO9";